import { BrowserRouter } from 'react-router-dom';

// routes
import AllRoutes from '.';
import ScrollToTop from './ScrollToTop';

const Routes = () => {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <AllRoutes />
        </BrowserRouter>
    );
};

export default Routes;
